import styled from "@emotion/styled";
import SpinnerForMap from "../../components/spinnerForMap";
import { css, keyframes } from "@emotion/react";
import {
  ChangeEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { UnifiedMap, UnifiedMarker, UnifiedOverlay, UnifiedPolyline } from "../../components/map";
import {
  DetectTodayResult,
  GetMobilityLive,
  GetMobilityLiveLevel,
} from "../../types/types";
import { useMapProvider } from "../../hooks/useMapProvider";
import { PhoneIcon } from "../../assets/icons/icons";
import usePostContactRecord from "../../hooks/usePostContactRecord";
import { useRecoilState } from "recoil";
import AlertModal from "../../components/alertModal";
import InfoContent from "./InfoContent";
import { normalizeLongitude, getKoreaRegionBoundary } from "../../utils/mapUtils";
import LiveBoard from "./liveBoard";
import ToastMsg from "../../components/toastMsg";
import { toastState } from "../../atoms/toast";
import userStorage from "../../utils/userStorage";
import { imageArray } from "../../utils/imageArray";
// import roadAccidentMap from "../../assets/images/roadAccidentMap.svg"; // 클러스터에서 제거됨
import theme from "../../theme";
import { useWindowSize } from "@reactuses/core";
import { AddressSearchBar } from "./AddressSearchBar";
import { AlertModalInput } from "../../components/alertModalInput";
import { useLocation } from "react-router-dom";
import { useI18n } from "../../locales";

// MAPTYPE은 동적으로 생성 (다국어 지원)
// mapProvider에 따라 다른 타입 반환
const getMapTypes = (t: any, mapProvider: "kakao" | "osm" = "kakao") => {
  if (mapProvider === "kakao") {
    return [
      { name: t.control.normal, value: 1 },
      { name: t.control.cadastral, value: 2, isToggle: true }, // 지적도는 토글 버튼
      { name: t.control.satellite, value: 3 },
    ];
  } else {
    return [
      { name: t.control.normal, value: 1 },
      { name: t.control.satellite, value: 3 },
    ];
  }
};
export interface HomeRouteState {
  state: {
    from: string;
    data: DetectTodayResult;
  };
}

const { md, lg } = theme.screen;

const KakaoMap: React.FC<{
  data?: GetMobilityLive[];
  isLoading: boolean;
  center: any;
  level: number;
  setCenter: any;
  setLevel: any;
  selectedInfo: any;
  setSelectedInfo: any;
  select: any;
  setSelect: any;
  showNum: any;
  setShowNum: any;
  showNokNum: any;
  setShowNokNum: any;
  leftFold: boolean;
  rightFold: boolean;
  isButtonVisible: boolean;
  setIsButtonVisible: any;
  bookmarkMarker: any;
  setBookmarkMarker: any;
  levelData2?: GetMobilityLiveLevel[];
  setClustererLevel2: any;
  clustererIsLoading?: boolean;
  isRefreshing?: boolean;
  mapContentsToggle?: boolean;
  setMapContentsToggle?: any;
  mapBound?: kakao.maps.LatLngBounds;
  setMapBound?: any;
  handleClickDevice: (el: GetMobilityLive) => void;
  activeRight?: boolean;
  openReport?: boolean;
  setOpenReport?: any;
  openReportModal?: () => void;
}> = (props) => {
  const { t } = useI18n();
  const {
    data,
    isLoading,
    center,
    setCenter,
    level,
    setLevel,
    selectedInfo,
    setSelectedInfo,
    select,
    setSelect,
    showNum,
    setShowNum,
    showNokNum,
    setShowNokNum,
    leftFold,
    rightFold,
    isButtonVisible,
    setIsButtonVisible,
    bookmarkMarker,
    setBookmarkMarker,
    levelData2,
    setClustererLevel2,
    clustererIsLoading,
    isRefreshing,
    mapContentsToggle,
    setMapContentsToggle,
    mapBound,
    setMapBound,
    handleClickDevice: originalHandleClickDevice,
    activeRight,
    openReport: openReportProp,
    setOpenReport: setOpenReportProp,
    openReportModal: openReportModalProp,
  } = props;
  const { width } = useWindowSize();
  const location = useLocation() as HomeRouteState;
  const [who, setWho] = useState(0);
  const user = userStorage.get();
  const isInplabAdmin = user?.area === "00000" && user?.grade === 2;
  const [showBoundary, setShowBoundary] = useState(false);
  
  // 우측 Shift + L + I + N + E 키 조합으로 경계 표시 토글
  useEffect(() => {
    if (!isInplabAdmin) return;
    
    const pressedKeys = new Set<string>();
    
    const handleKeyDown = (e: KeyboardEvent) => {
      // 우측 Shift 체크
      if (e.shiftKey && e.location === KeyboardEvent.DOM_KEY_LOCATION_RIGHT) {
        pressedKeys.add('ShiftRight');
      }
      // L, I, N, E 키 체크
      const key = e.key.toLowerCase();
      if (key === 'l') pressedKeys.add('L');
      if (key === 'i') pressedKeys.add('I');
      if (key === 'n') pressedKeys.add('N');
      if (key === 'e') pressedKeys.add('E');
      
      // 모든 키가 동시에 눌렸는지 확인
      if (pressedKeys.has('ShiftRight') && 
          pressedKeys.has('L') && 
          pressedKeys.has('I') && 
          pressedKeys.has('N') && 
          pressedKeys.has('E')) {
        setShowBoundary(prev => !prev);
        // 키 상태 초기화
        pressedKeys.clear();
      }
    };
    
    const handleKeyUp = (e: KeyboardEvent) => {
      // 키를 떼면 Set에서 제거
      if (e.shiftKey && e.location === KeyboardEvent.DOM_KEY_LOCATION_RIGHT) {
        pressedKeys.delete('ShiftRight');
      }
      const key = e.key.toLowerCase();
      if (key === 'l') pressedKeys.delete('L');
      if (key === 'i') pressedKeys.delete('I');
      if (key === 'n') pressedKeys.delete('N');
      if (key === 'e') pressedKeys.delete('E');
    };
    
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [isInplabAdmin]);
  
  // prop이 있으면 prop을 사용하고, 없으면 내부 상태 사용
  const [localOpenReport, setLocalOpenReport] = useState(false);
  const openReport = openReportProp !== undefined ? openReportProp : localOpenReport;
  const setOpenReport = setOpenReportProp || setLocalOpenReport;
  const [openPhoneModal, setOpenPhoneModal] = useState(false);
  const [mapTypeId, setMapTypeId] = useState(1);
  const [isCadastralOn, setIsCadastralOn] = useState(false); // 지적도 온오프 상태
  const [charger, setCharger] = useState("");
  const [visibleMarkers, setVisibleMarkers] =
    useState<GetMobilityLive[]>();
  const [markers, setMarkers] = useState<GetMobilityLive[]>();
  const [map, setMap] = useState<kakao.maps.Map>();
  const [toastOpen, setToastOpen] = useRecoilState(toastState);
  const inputRef = useRef<HTMLInputElement>(null);
  const isProgrammaticMoveRef = useRef(false); // 의도적인 지도 이동 플래그
  const currentOverlayTypeIdRef = useRef<kakao.maps.MapTypeId | null>(null); // 현재 오버레이 타입 추적
  const [visibleItems, setVisibleItems] = useState({
    item: "",
    phone: "",
  });
  
  // 맵 제공자를 state로 관리 (center와 level 모두 고려)
  const currentMapProvider = useMapProvider(center.lat, center.lng, level).mapProvider;
  const [mapProvider, setMapProvider] = useState(currentMapProvider);
  const [lastCenter, setLastCenter] = useState(center);
  const [lastLevel, setLastLevel] = useState(level);
  // const [isMapTransitioning, setIsMapTransitioning] = useState(false);
  
  // mapProvider가 실제로 변경될 때만 업데이트
  useEffect(() => {
    // center가 의미있게 변경되었는지 확인 (소수점 3자리, 약 100m)
    const latDiff = Math.abs(center.lat - lastCenter.lat);
    const lngDiff = Math.abs(center.lng - lastCenter.lng);
    const hasMovedSignificantly = latDiff > 0.001 || lngDiff > 0.001;
    
    // level이 변경되었는지 확인 (줌 레벨 기반 전환)
    const levelChanged = level !== lastLevel;
    
    console.log(`🗺️ [kakaoMap] currentMapProvider=${currentMapProvider}, mapProvider=${mapProvider}, hasMovedSignificantly=${hasMovedSignificantly}, levelChanged=${levelChanged}`);
    
    if (currentMapProvider !== mapProvider && (hasMovedSignificantly || levelChanged)) {
      console.log(`🗺️ [kakaoMap] 지도 전환: ${mapProvider} → ${currentMapProvider}`);
      // 지도 제공자 즉시 변경 (지도는 바로 표시)
      setMapProvider(currentMapProvider);
      setLastCenter(center);
      setLastLevel(level);
      
      // mapBound만 초기화 (새 지도의 bounds로 업데이트되도록)
      setMapBound(undefined);
    }
  }, [currentMapProvider, mapProvider, center, lastCenter, level, lastLevel]);
  
  // selectedInfo가 변경되면 의도적인 이동으로 플래그 설정 (농기계 선택 시)
  useEffect(() => {
    if (selectedInfo) {
      isProgrammaticMoveRef.current = true;
    }
  }, [selectedInfo]);
  
  // handleClickDevice 래퍼 - 플래그 설정 후 원래 함수 호출
  const handleClickDevice = (el: GetMobilityLive) => {
    console.log(`🎯 [handleClickDevice] 호출: device_pid=${el.device_pid}, lat=${el.latitude}, lng=${el.longitude}, level=${level}, mapProvider=${mapProvider}`);
    isProgrammaticMoveRef.current = true;
    originalHandleClickDevice(el);
    
    // 호출 직후 상태 확인 (비동기이므로 다음 틱에 확인)
    setTimeout(() => {
      console.log(`🔍 [handleClickDevice] 상태 확인: select=${select}, selectedInfo=${selectedInfo?.device_pid}, level=${level}`);
    }, 50);
  };

  function handleInputFocus() {
    setIsButtonVisible(true);
    setSelect("");
    setShowNokNum(false);
    setShowNum(false);
    setBookmarkMarker({
      lat: Number(user?.latitude),
      lng: Number(user?.longitude),
      visible: false,
    });
  }

  const handleCloseRestore = (
    _?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setToastOpen((prev) => {
      return { ...prev, restoreSuccess: false };
    });
  };

  const openReportModal = openReportModalProp || (() => {
    if (setOpenReport) {
      setOpenReport(true);
    }
  });

  const onPressNo = () => {
    setOpenPhoneModal(false);
    setVisibleItems({
      item: "",
      phone: "",
    });
    setCharger("");
  };

  const onChangeCharger = (e: ChangeEvent<HTMLInputElement>) => {
    setCharger(e.currentTarget.value);
  };

  const { mutate } = usePostContactRecord({
    mobility_seq: selectedInfo?.seq as number,
    who,
    reader_name: charger,
    admin_idx: user?.idx as number,
    showNum: () => setShowNum(true),
    showNokNum: () => setShowNokNum(true),
    closeModal: onPressNo,
    phone: visibleItems.phone,
    name: selectedInfo?.name || selectedInfo?.owner || "",
  });

  const onPressYes = () => {
    mutate();
  };

  const onClickMapType = (el: { name: string; value: number; isToggle?: boolean }) => {
    if (el.isToggle) {
      // 지적도는 토글 버튼
      setIsCadastralOn((prev) => !prev);
    } else {
      // 일반 또는 위성 지도
      setMapTypeId(el.value);
    }
  };

  // mapTypeId 변경 시 지도 타입 업데이트
  useEffect(() => {
    if (!map || mapProvider !== "kakao") return;

    try {
      map.setMapTypeId(mapTypeId === 3 ? kakao.maps.MapTypeId.HYBRID : kakao.maps.MapTypeId.ROADMAP);
    } catch (e) {
      console.error("지도 타입 설정 에러:", e);
    }
  }, [map, mapTypeId, mapProvider]);

  // 지적도 온오프 상태 변경 시 오버레이 추가/제거
  useEffect(() => {
    if (!map || mapProvider !== "kakao") return;

    // 기존 오버레이 제거
    if (currentOverlayTypeIdRef.current) {
      try {
        map.removeOverlayMapTypeId(currentOverlayTypeIdRef.current);
        currentOverlayTypeIdRef.current = null;
      } catch (e) {
        console.error("오버레이 제거 에러:", e);
      }
    }

    // 지적도가 켜져있으면 오버레이 추가
    if (isCadastralOn) {
      try {
        map.addOverlayMapTypeId(kakao.maps.MapTypeId.USE_DISTRICT);
        currentOverlayTypeIdRef.current = kakao.maps.MapTypeId.USE_DISTRICT;
      } catch (e) {
        console.error("지적편집도 오버레이 추가 에러:", e);
      }
    }
  }, [map, isCadastralOn, mapProvider]);

  const handleSetCenter = useCallback(
    (lat: string | number, lng: string | number) => {
      if (width <= 450) {
        setCenter({
          lat: Number(lat) + 0.002,
          lng: Number(lng),
        });
        return;
      }
      if (width > 450 && width < theme.screen.md) {
        setCenter({
          lat: Number(lat) + 0.003,
          lng: Number(lng),
        });
        return;
      }
      if (width >= theme.screen.md && width < theme.screen.lg) {
        setCenter({
          lat: Number(lat) + 0.0035,
          lng: Number(lng) - 0.002,
        });
        return;
      }
      if (width >= theme.screen.lg) {
        setCenter({
          lat: Number(lat) + 0.0035,
          lng: Number(lng),
        });
        return;
      }
    },
    [width, location]
  );

  const handleBookmark = (
    level: number,
    lat: string | number,
    lng: string | number
  ) => {
    setLevel(level);
    setCenter({ lat: Number(lat), lng: Number(lng) });
    setBookmarkMarker({
      lat: Number(lat),
      lng: Number(lng),
      visible: true,
    });
    setIsButtonVisible(false); // 검색창 닫기
  };

  useEffect(() => {
    if (data) {
      setMarkers(data);
    }
  }, [data]);

  // 농기계 상세 조회에서 접근
  useEffect(() => {
    if (!location) return;
    let timeoutId: NodeJS.Timeout | undefined;
    if (location.state) {
      const { state } = location;
      if (state.from === "mobileList") {
        setSelect(state.data.device_pid);
        setLevel(3);
        timeoutId = setTimeout(() => {
          handleSetCenter(state.data.latitude, state.data.longitude);
        }, 100);
        setSelectedInfo(state.data);
      }
    }
    return () => timeoutId && clearTimeout(timeoutId);
  }, [location, setCenter, setLevel, setSelect, setSelectedInfo]);

  // mapProvider 변경 시 mapBound 초기화
  const prevMapProviderRef = useRef(mapProvider);
  
  useEffect(() => {
    // mapProvider가 변경되면 bounds 초기화
    if (prevMapProviderRef.current !== mapProvider) {
      prevMapProviderRef.current = mapProvider;
      setMapBound(undefined);
      setVisibleMarkers([]);
    }
  }, [mapProvider]);

  useEffect(() => {
    if (!mapBound) {
      // mapBound가 없으면 빈 배열 (지도 전환 중)
      console.log(`⚠️ mapBound 없음, visibleMarkers = []`);
      setVisibleMarkers([]);
      return;
    }
    
    // bounds 정보를 먼저 추출
    const sw = mapBound.getSouthWest();
    const ne = mapBound.getNorthEast();
    
    const swLat = typeof sw.getLat === 'function' ? sw.getLat() : (sw as any).lat;
    const swLng = typeof sw.getLng === 'function' ? sw.getLng() : (sw as any).lng;
    const neLat = typeof ne.getLat === 'function' ? ne.getLat() : (ne as any).lat;
    const neLng = typeof ne.getLng === 'function' ? ne.getLng() : (ne as any).lng;
    
    const visibleMarkers = markers?.filter((el: GetMobilityLive) => {
      try {
        // 마커가 bounds 안에 있는지 직접 체크
        const isInBounds = (
          el.latitude >= swLat &&
          el.latitude <= neLat &&
          el.longitude >= swLng &&
          el.longitude <= neLng
        );
        
        return isInBounds;
      } catch (e) {
        console.error("Marker contain check error:", e);
        return false;
      }
    });
    
    setVisibleMarkers(visibleMarkers);
  }, [markers, mapBound, center, mapProvider]);

  // 지도레벨 확인 (level state 사용하여 무한 루프 방지)
  useEffect(() => {
    if (select) return;
    if (map && data && levelData2) {
      if (level >= 11) {
        setClustererLevel2(50);
        return;
      }

      if (level <= 10 && level >= 8) {
        setClustererLevel2(15);
        return;
      }

      if (level < 8) {
        setClustererLevel2(5);
        return;
      }
    }
  }, [map, data, levelData2, level, select]);

  // 뷰포트 크기 확인
  // useEffect(() => {
  //   if (width < theme.screen.md) {
  //     if (select) {
  //       setMapContentsToggle(true);
  //       return;
  //     } else if (!select) {
  //       setMapContentsToggle(false);
  //     }
  //   } else if (width >= theme.screen.md) {
  //     setMapContentsToggle(false);
  //   }
  // }, [select, width]);

  useEffect(() => {
    if (!map) return;
    setMapBound(map.getBounds());
  }, [map]);

  // console.log("전체데이터", data);
  // console.log(map?.getBounds());
  // console.log(visibleItems);

  return (
    <Wrapper>
      {/* 지도 이동·조건 변경으로 다시 받는 중에는 기존 마커를 그대로 두고
          상단에 토스트로 작게만 알린다 (화면 전체를 덮지 않는다) */}
      {isRefreshing && !(clustererIsLoading || isLoading) && (
        <RefreshingBadge>
          <RefreshingDot />
          {t.common.loading}
        </RefreshingBadge>
      )}
      {(clustererIsLoading || isLoading) && (
        // 스피너
        <SpinnerContainer>
          {
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <SpinnerForMap />
              <p
                style={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "x-large",
                  textShadow: "0px 0px 7px rgba(0,0,0,0.9)",
                }}
              >
                조회 중입니다.
              </p>
            </div>
          }
        </SpinnerContainer>
      )}
      {/* 지도 전환 로딩 제거 - 즉시 전환 */}
      <UnifiedMap
        onCreate={(map) => {
          setMap(map);
        }}
        center={{
          lat: Number(center?.lat) || 37.5665, // 기본값 설정
          lng: normalizeLongitude(Number(center?.lng) || 126.9780), // 경도 정규화
        }}
        onClick={() => {
          if (openReport) return;
          setShowNokNum(false);
          setShowNum(false);
          setIsButtonVisible(false);
          inputRef.current?.blur();
          setBookmarkMarker({
            lat: Number(user?.latitude),
            lng: Number(user?.longitude),
            visible: false,
          });
          if (width > theme.screen.md) {
            setSelect("");
            setSelectedInfo("");
          }
        }}
        style={{ width: "100%", height: "100%" }}
        level={level}
        disableDoubleClickZoom={true}
        onIdle={(target) => {
          if (openReport) return;
          
          // bounds 업데이트 (onIdle에서만 신뢰할 수 있음)
          const bounds = target.getBounds();
          setMapBound(bounds);
          
          const currentLevel = target.getLevel();
          
          // level이 실제로 변경되었을 때만 업데이트 (handleClickDevice의 setLevel을 보호)
          if (currentLevel !== level) {
            setLevel(currentLevel);
          }
          
          // center가 의미있게 변경되었을 때만 업데이트 (무한 루프 방지)
          const newLat = target.getCenter().getLat();
          const newLng = normalizeLongitude(target.getCenter().getLng()); // 경도 정규화
          const normalizedCenterLng = normalizeLongitude(center.lng); // 기존 center도 정규화
          
          const latDiff = Math.abs(newLat - center.lat);
          const lngDiff = Math.abs(newLng - normalizedCenterLng);
          
          // 0.005도 이상 차이날 때만 업데이트 (약 500m, 사용자의 명시적 이동)
          if (latDiff > 0.005 || lngDiff > 0.005) {
            setCenter({
              lat: newLat,
              lng: newLng,
            });
            
            // 지도가 크게 이동했을 때 선택 해제 판단
            if (width > theme.screen.md && select) {
              // selectedInfo가 있고, 현재 center가 selectedInfo의 좌표 근처라면 의도적인 이동
              let isIntentionalMove = isProgrammaticMoveRef.current;
              
              if (selectedInfo) {
                const selectedLat = selectedInfo.latitude;
                const selectedLng = selectedInfo.longitude;
                const distToSelected = Math.sqrt(
                  Math.pow(newLat - selectedLat, 2) + Math.pow(newLng - selectedLng, 2)
                );
                
                // 선택된 좌표로 이동 중이면 의도적인 이동으로 판단 (약 0.01도 = 1km 이내)
                if (distToSelected < 0.01) {
                  isIntentionalMove = true;
                }
              }
              
              // 의도적인 이동이 아닐 때만 선택 해제
              if (!isIntentionalMove) {
                setSelect("");
                setSelectedInfo(undefined);
              }
            }
            
            // 플래그 초기화 (한 번의 onIdle 후에는 다시 일반 동작으로)
            isProgrammaticMoveRef.current = false;
          } else if (latDiff > 0.0001 || lngDiff > 0.0001) {
            // 작은 이동은 center만 업데이트 (선택 해제는 하지 않음)
            setCenter({
              lat: newLat,
              lng: newLng,
            });
          }
        }}
        mapTypeId={mapTypeId}
      >
        {/* 한국 영역 경계 폴리곤 (카카오맵 → OSM 전환 영역 표시) - 인플랩 관리자만 표시 */}
        {isInplabAdmin && showBoundary && (
          <>
            <UnifiedPolyline
              path={getKoreaRegionBoundary()}
              strokeWeight={3}
              strokeColor="#FF6B6B"
              strokeOpacity={0.6}
              strokeStyle="dash"
            />
            
            {/* 지도 중심점 마커 (카카오맵 → OSM 전환 기준점) */}
            <UnifiedMarker
              position={center}
              image={{
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiIGZpbGw9IiNGRjZCNkIiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjQiIGZpbGw9IiNGRkZGRkYiLz4KPC9zdmc+",
                size: { width: 24, height: 24 }
              }}
              zIndex={1000}
            />
          </>
        )}
        
        {isButtonVisible && bookmarkMarker.visible && (
          <UnifiedMarker
            position={{ lat: bookmarkMarker.lat, lng: bookmarkMarker.lng }}
          />
        )}
        
        {/* 선택된 기기 마커 (data에 없을 때를 대비) */}
        {selectedInfo && select && level < 7 && (() => {
          const selectedInData = data?.find(el => el.device_pid === select);
          if (selectedInData) {
            return null; // data에 있으면 아래에서 렌더링됨
          }
          console.log(`⚠️ [선택된 기기 별도 렌더링] device_pid=${select}, data에 없음`);
          return (
            <div key={`selected-${select}`}>
              <UnifiedMarker
                position={{ lat: selectedInfo.latitude, lng: selectedInfo.longitude }}
                image={{
                  src: imageArray
                    .find((image) => image.device === selectedInfo.mobility_type)
                    ?.images.find((elel) => {
                      // 상태 확인 (다국어 지원)
                      const isNotRunning = !selectedInfo.status || 
                        selectedInfo.status === "미운행" || 
                        (t && selectedInfo.status !== t.control.operationRunning && selectedInfo.status !== t.control.operationEnd);
                      const isRunning = selectedInfo.status === "운행중" || (t && selectedInfo.status === t.control.operationRunning);
                      const isNormal = selectedInfo.event_accident === "정상" || (t && selectedInfo.event_accident === t.control.normal);
                      
                      if (isNotRunning) {
                        return elel.type === "sleep";
                      } else if (isRunning && !isNormal) {
                        return elel.type === "danger";
                      } else if (isRunning && isNormal && selectedInfo.events !== null) {
                        return elel.type === "warning";
                      } else {
                        return elel.type === "ok";
                      }
                    })?.image as string,
                  size: {
                    width: 40,
                    height: 44,
                  },
                }}
                clickable={true}
                title={selectedInfo.status}
                onClick={() => {
                  handleClickDevice(selectedInfo);
                  inputRef.current?.blur();
                }}
              />
              <UnifiedOverlay
                clickable={true}
                position={{ lat: selectedInfo.latitude, lng: selectedInfo.longitude }}
                yAnchor={1.13}
                xAnchor={0.5}
                zIndex={theme.zindex.overlayMap}
                interactive={true}
              >
                <InfoContent
                  idx={-1}
                  data={selectedInfo}
                  setWho={setWho}
                  setOpenPhoneModal={setOpenPhoneModal}
                  showNum={showNum}
                  showNokNum={showNokNum}
                  openReportModal={openReportModal}
                  setSelect={setSelect}
                  setSelectedInfo={setSelectedInfo}
                  setVisibleItems={setVisibleItems}
                />
              </UnifiedOverlay>
            </div>
          );
        })()}
        
        {/* 지도 레벨 6이하 - 마커 */}
        {level < 7 && (() => {
          console.log(`📊 [마커 렌더링 시작] data 길이=${data?.length}, select=${select}, selectedInfo=${selectedInfo?.device_pid}, level=${level}, mapProvider=${mapProvider}`);
          if (select && data) {
            const selectedInData = data.find(el => el.device_pid === select);
            console.log(`🔍 [data 확인] select=${select}가 data에 ${selectedInData ? '있음✅' : '없음❌'}`);
          }
          return data?.map((el, idx) => {
            // 선택된 기기 렌더링 확인
            if (select === el.device_pid) {
              console.log(`📍 [마커 렌더링] device_pid=${el.device_pid}, select=${select}, selectedInfo=${selectedInfo?.device_pid}, level=${level}`);
            }
            return (
            <div key={idx.toString()}>
              <UnifiedMarker
                position={{ lat: el.latitude, lng: el.longitude }}
                key={`${el.device_pid}`}
                image={{
                  src: imageArray
                    .find((image) => image.device === el.mobility_type)
                    ?.images.find((elel) => {
                      // 상태 확인 (다국어 지원)
                      const isNotRunning = !el.status || 
                        el.status === "미운행" || 
                        (t && el.status !== t.control.operationRunning && el.status !== t.control.operationEnd);
                      const isRunning = el.status === "운행중" || (t && el.status === t.control.operationRunning);
                      const isNormal = el.event_accident === "정상" || (t && el.event_accident === t.control.normal);
                      
                      if (isNotRunning) {
                        return elel.type === "sleep";
                      } else if (isRunning && !isNormal) {
                        return elel.type === "danger";
                      } else if (isRunning && isNormal && el.events !== null) {
                        return elel.type === "warning";
                      } else {
                        return elel.type === "ok";
                      }
                    })?.image as string,
                  size: {
                    width: 40,
                    height: 44,
                  },
                }}
                clickable={true}
                title={el.status}
                onClick={() => {
                  handleClickDevice(el);
                  inputRef.current?.blur();
                }}
              />
              {select && select === el.device_pid && selectedInfo && (() => {
                console.log(`✅ InfoContent 렌더링: device_pid=${el.device_pid}, select=${select}, level=${level}, mapProvider=${mapProvider}`);
                return (
                  <UnifiedOverlay
                    clickable={true}
                    position={{ lat: el.latitude, lng: el.longitude }}
                    yAnchor={1.13}
                    xAnchor={0.5}
                    zIndex={theme.zindex.overlayMap}
                    interactive={true}
                  >
                    <InfoContent
                    idx={idx}
                    data={el}
                    setWho={setWho}
                    setOpenPhoneModal={setOpenPhoneModal}
                    showNum={showNum}
                    showNokNum={showNokNum}
                    openReportModal={openReportModal}
                    setSelect={setSelect}
                    setSelectedInfo={setSelectedInfo}
                    setVisibleItems={setVisibleItems}
                  />
                </UnifiedOverlay>
                );
              })()}
            </div>
            );
          });
        })()}

        {/* 지도레벨 7이상 - 클러스터 마커 */}
        {levelData2 &&
          level >= 7 &&
          levelData2?.map((el, index) => (
            <div key={`${el.latitude}-${el.longitude}-${index}`}>
              <UnifiedOverlay
                position={{
                  lat: el.latitude,
                  lng: el.longitude,
                }}
                clickable={true}
                zIndex={2}
                variant={"cluster"}
                onClick={() => {
                  // 맵이 준비되지 않았거나 로딩 중이면 실행하지 않음
                  if (isLoading || clustererIsLoading || !map) {
                    return;
                  }
                  
                  // 맵이 준비될 때까지 약간 지연하여 줌 동작 실행
                  setTimeout(() => {
                    try {
                      // 맵 인스턴스가 여전히 유효한지 확인
                      if (!map) return;
                      
                      // 클러스터 클릭 시 level state를 사용하여 줌 인
                      if (level >= 11) {
                        setLevel(10);
                        setCenter({
                          lat: el.latitude,
                          lng: el.longitude,
                        });
                        return;
                      }
                      if (level < 11 && level >= 8) {
                        setLevel(7);
                        setCenter({
                          lat: el.latitude,
                          lng: el.longitude,
                        });
                        return;
                      }
                      if (level <= 7) {
                        setLevel(5);
                        setCenter({
                          lat: el.latitude,
                          lng: el.longitude,
                        });
                        return;
                      }
                    } catch (error) {
                      console.error('클러스터 클릭 핸들러 에러:', error);
                    }
                  }, 100);
                }}
              >
                <p>
                  <span>{` ${el.count}`}</span>
                </p>
              </UnifiedOverlay>
            </div>
          ))}
      </UnifiedMap>

      {/* 일반&위성 버튼 */}
      <ToggleWrapper
        //style={setRightFold?{right: "30px"}:{marginRight: "420px"}}
        setFold={rightFold}
        activeRight={activeRight}
        style={
          mapContentsToggle ? { display: "none" } : { display: "block" }
        }
      >
        {getMapTypes(t, mapProvider).map((el, idx) => {
          const mapTypes = getMapTypes(t, mapProvider);
          const isMiddle = mapProvider === "kakao" && mapTypes.length === 3 && idx === 1;
          // 지적도는 토글 버튼이므로 isCadastralOn으로 선택 상태 판단
          const isSelected = el.isToggle 
            ? isCadastralOn 
            : el.value === mapTypeId;
          return (
            <ToggleBox
              key={el.name}
              onClick={() => onClickMapType(el)}
              isSelected={isSelected}
              isFirst={idx === 0}
              isMiddle={isMiddle}
            >
              {el.name}
            </ToggleBox>
          );
        })}
      </ToggleWrapper>

      {/* 지도 내 농기계 컴포넌트 */}
      <LiveBoard
        data={visibleMarkers}
        setFold={leftFold}
        setMapContentsToggle={setMapContentsToggle}
        mapContentsToggle={mapContentsToggle}
        selectedInfo={selectedInfo}
      ></LiveBoard>

      {/* 검색창 */}
      <AddressSearchBar
        leftFold={leftFold}
        isButtonVisible={isButtonVisible}
        setIsButtonVisible={setIsButtonVisible}
        mapContentsToggle={mapContentsToggle}
        inputRef={inputRef}
        handleInputFocus={handleInputFocus}
        handleBookmark={handleBookmark}
        mapProvider={mapProvider}
      />
      <AlertModal
        open={openPhoneModal}
        onPressNo={onPressNo}
        title={t.control.openContact}
        content={t.control.protectDevicePrivacy(visibleItems.item)}
        content2={t.control.enterOfficerName}
        confirmText={t.control.openContactButton}
        other={
          <AlertModalInput
            onChange={onChangeCharger}
            placeholder={t.control.enterOfficerName}
            value={charger}
          />
        }
        onPressYes={onPressYes}
        icon={<PhoneIcon />}
        otherFilled={Boolean(charger.length)}
      />
      <ToastMsg
        open={toastOpen.restoreSuccess}
        handleClose={handleCloseRestore}
        message="전복사고 감지가 해제되었습니다."
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  flex: 1;
  position: relative;
  width: 100%;
  height: 100%;

  /* height: calc(var(--vh, 1vh) * 100 - 100px); */
  /* @media (max-width: ${md}px) {
    height: calc(var(--vh, 1vh) * 100 - 50px);
    height: 100%;

  } */
  /* @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    height: 100vh;
  } */
`;

export const SecondRow = styled.div`
  width: 463px;
  height: 201px;
  display: flex;
  background: ${theme.color.neutral_50};
  border-radius: 20px;
  margin-top: 40px;
  padding: 20px;
  margin-bottom: 40px;
`;

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ThinText = styled.span`
  font-weight: 400;
  margin-right: 10px;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_500};
`;

export const SRLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  flex: 1;
  border-right: 1px solid ${theme.color.neutral_200};
`;

export const SRRight = styled.div`
  display: flex;
  padding-left: 20px;
  flex-direction: column;
  gap: 25px;
  flex: 1;
`;

export const TextWrapper2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const SubText = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.color.neutral_500};
`;

export const MainText = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${theme.color.neutral_600};
`;

export const ThickText = styled.span`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_500};
`;

export const TextWrapper = styled.p`
  margin-bottom: 15px;
`;
const utilBarRightClose = keyframes`
from{
  right:480px;
}
to{
  right:30px;
}
`;
const utilBarRightOpen = keyframes`
from{
  right:30px;
}
to{
  right:480px;
}
`;
export const ToggleWrapper = styled.div<{ setFold?: boolean; activeRight?: boolean }>`
  position: absolute;
  z-index: ${({ activeRight }) => {
    if (activeRight === false) return 1;
    return 50;
  }};
  cursor: pointer;
  top: 20px;

  @media (max-width: 420px) {
    right: 65%;
  }

  @media (min-width: 420px) and (max-width: ${md}px) {
    right: 290px;
  }

  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    right: 30px;
  }

  @media (min-width: ${lg + 1}px) {
    right: 480px;
    ${({ setFold }) =>
      setFold
        ? css`
            animation: ${utilBarRightClose} 0.5s ease;
          `
        : !setFold
        ? css`
            animation: ${utilBarRightOpen} 0.5s ease;
          `
        : null}
    animation-fill-mode:both;
  }
`;

export const ToggleBox = styled.button<{
  isFirst: boolean;
  isSelected: boolean;
  isMiddle?: boolean;
}>`
  width: 39px;
  height: 44px;
  border-top-left-radius: ${({ isFirst }) => (isFirst ? "73px" : "0px")};
  border-top-right-radius: ${({ isFirst }) => (isFirst ? "73px" : "0px")};
  border-bottom-left-radius: ${({ isFirst, isMiddle }) =>
    isMiddle ? "0px" : isFirst ? "0px" : "73px"};
  border-bottom-right-radius: ${({ isFirst, isMiddle }) =>
    isMiddle ? "0px" : isFirst ? "0px" : "73px"};
  border-bottom: ${({ isFirst, isMiddle }) =>
    isMiddle ? `1px solid #E0E0E0` : isFirst ? `1px solid ${theme.color.neutral_200}` : ""};
  background: ${theme.color.white};
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  font-weight: ${({ isSelected }) => (isSelected ? 700 : 400)};
  font-size: 13px;
  line-height: 15px;
  color: ${({ isSelected }) =>
    isSelected ? theme.color.neutral_800 : theme.color.neutral_300};
  text-align: center;
  &:hover {
    background-color: ${theme.color.neutral_100};
  }
`;



const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const pulse = keyframes`
  0% { opacity: 0.35; }
  50% { opacity: 1; }
  100% { opacity: 0.35; }
`;

const RefreshingBadge = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 110;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 16px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  pointer-events: none;
  animation: ${fadeIn} 0.25s ease-in;

  /* 지도 유형 토글이 가운데 근처로 오는 폭에서는 한 단 아래로 내린다 */
  @media (min-width: 420px) and (max-width: ${md}px) {
    top: 56px;
  }
`;

const RefreshingDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #ffffff;
  animation: ${pulse} 1s ease-in-out infinite;
`;

const SpinnerContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(231, 229, 228, 0.6);
`;

export default KakaoMap;
